import { CartResponse } from "@/networking/carts.api";

export type PusherEventType = "cart_update" | "external_discount_applied";

/**
 * Uncompressed cart update payload (payloads < 8KB).
 */
export interface PusherCartUpdatePayload {
  event_type: PusherEventType;
  cart: CartResponse["cart"];
  meta: CartResponse["meta"];
}

/**
 * Compressed cart update payload (payloads 8KB-9.5KB).
 *
 * Backend compresses larger payloads using Zlib + Base64 encoding.
 */
export interface CompressedPusherPayload {
  compressed: true;
  data: string; // Base64-encoded Zlib-compressed JSON
  original_size: number; // Original size before compression (bytes)
}

export type PusherPayload = PusherCartUpdatePayload | CompressedPusherPayload;

export function isCompressedPayload(
  payload: PusherPayload,
): payload is CompressedPusherPayload {
  return (
    typeof payload === "object" &&
    payload !== null &&
    "compressed" in payload &&
    payload.compressed === true
  );
}

export interface PusherConfig {
  key: string;
  cluster: string;
  enabled: boolean;
  authEndpoint: string;
}

export interface PusherConnectionStatus {
  state: "connected" | "connecting" | "disconnected" | "unavailable";
  isConnected: boolean;
  error?: Error;
}
